import oa_request from '../utils/oa-request'
import fw_request from '../utils/fw-request'
import xc_request from '../utils/xc-request'
import request from '../utils/request'
//外部跳转登录
export function jumplogin(data){
    return request({
        url:'/check',
        method:'post',
        data
    })
}

//外部跳转登录
export function jumplogin_fw(data){
    return fw_request({
        url:'/back/v1/common/check',
        method:'get',
        data
    })
}

//外部跳转登录
export function jumplogin_xc(data){
    return xc_request({
        url:'/admin/v1/menHuFreeLogin/Index/index',
        method:'get',
        data
    })
}

//员工画像下拉
export function userPortraitOptions(params){
    return request({
        url:'/v1/admin/userPortraitOptions',
        method:'get',
        params
    })
}

//注册
export function registerUser(data){
    return request({
        url:'/v1/admin/registerUser',
        method:'post',
        data
    })
}

//成员画像详情
export function detail(params){
    return request({
        url:'/v1/admin/detail',
        method:'get',
        params
    })
}

//画像审核
export function auditAdmin(data){
    return request({
        url:'/v1/admin/auditAdmin',
        method:'post',
        data
    })
}

//判断用户 是否在某个用户组

export function adminInGroup(params){
    return request({
        url:'/v2/group/adminInGroup',
        method:'get',
        params
    })
}

//画像编辑OR删除
export function editUser(data){
    return request({
        url:'/v1/admin/editUser',
        method:'post',
        data
    })
}


//微信扫码登录
export function wxlogin(data){
    return request({
        url:'/WeChatAuthLogin',
        method:'get',
        params:data
    })
}

//微信扫码绑定
export function wx_bind(data){
    return request({
        url:'/WeChatAuthLogin',
        method:'post',
        data
    })
}